import React, {
  useRef,
  useEffect,
  useState
} from 'react';
import cn from 'classnames';
import styles from './footer.module.scss';
import userInfo from '@utility';
import { LABEL } from '@veriables';
import { getObjectValue } from '@utility/utills';
import CartIcon from '@assets/images/newUI/Header/CartIcon';
import LanguageArrow from '@assets/images/newUI/Header/LanguageArrow';
import languageData from '@components/common/header/language.json';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCheckoutSlider, setActiveCategory, pushMenuItemsByScreenId, showLanguageModal
} from '@reducers/orders';
import SearchIcon from '@assets/images/SearchFormIcon';
import CrossIcon from '@assets/images/crossIcon';
import { usePopper } from 'react-popper';
import ProfileIcon from '@assets/images/newUI/Header/ProfileIcon';
import AccessibilityIconButton from '@components/common/header/AccessibilityIconButton';
import { Portal } from 'react-overlays';
import LanguageIcon from '../../../assets/images/newUI/Language';

const isMobile = window.innerWidth < 1023;
const DesktopMenu = ({ ...props }) => {
  const dispatch = useDispatch();
  const iconRef = useRef();
  const dropdownRef = useRef();
  const popper = usePopper(iconRef, dropdownRef, {
    placement: 'bottom-start',
    modifiers: [{ name: 'offset', options: { offset: [0, 8] } }],
  });
  const isIos = JSON.parse(window.localStorage.getItem('ios'));
  const {
    isLanguageModal
  } = useSelector(state => state.orders);
  const userWayAccountId = props?.popInData?.store?.accessibilityInfo?.userWayAccountId && !isIos;
  const styless = popper?.styles || {};
  const attributes = popper?.attributes || {};
  const { pathname } = window.location;
  const renderLanguageHeader = !pathname.includes('/order-item/') && !pathname.includes('/receipt/display') && !pathname.includes('/loyalty-offer-details');

  const getSelectedLanguage = () => {
    const langId = window.sessionStorage.getItem('languageId');
    let result = getObjectValue(() => props.themeProperties.languageId, null);
    if (langId) {
      result = Number(langId);
    }
    return result;
  };
  const handleClickOutside = (e) => {
    if (
      iconRef.current
      && !iconRef.current.contains(e.target)
      && dropdownRef.current
      && !dropdownRef.current.contains(e.target)
    ) {
      dispatch(showLanguageModal(false));
    }
  };

  useEffect(() => {
    if (isLanguageModal) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isLanguageModal]);
  const langId = window.sessionStorage.getItem('languageId');
  useEffect(() => {
    dispatch(showLanguageModal(false));
  }, [window.location.pathname]);
  useEffect(() => {
    props.setSelectedLanguageId(getSelectedLanguage());
  }, [isLanguageModal, langId]);

  // useEffect(() => {
  //   props.handleLanguageSelection(window.sessionStorage.getItem('languageId'));
  // }, [props.setSelectedLanguageId]);

  useEffect(() => {
    if (!isLanguageModal) {
      window.sessionStorage.removeItem('languageModal');
    }
  }, [isLanguageModal]);
  const onClickHandler = () => {
    const path = window.location.pathname;
    const brandId = path.split('/')[2];
    const isFromLocator = window.sessionStorage.getItem('isFromLocator') === 'true';
    const blockedRoutes = ['/pickup-time', '/guest-spot', '/spot-screen', '/mydata', '/account', '/waitlist-confirmation', '/check-paid', '/login', '/dashboard', '/receipt', '/payment-success', '/survey', '/specials', '/check-number'];
    if (blockedRoutes.some(route => path.startsWith(route))) return;
    const isListing = path.startsWith(`/brand/${brandId}/listing`);
    const isLocator = path.startsWith(`/brand/${brandId}/locator`);
    const originalUrl = window.sessionStorage.getItem('originalUrl');
    if (originalUrl?.includes('/wallet/loyalties/')) return;
    if (isListing && isFromLocator) {
      props.navigateTo(`/brand/${brandId}/locator`);
      return;
    }
    if (isLocator) return;
    if (path.includes('/listing') && !isFromLocator) {
      return;
    }
    // Normal navigation to orders
    const firstCategory = props?.menusList[props.menuIndex]?.screens[0];
    if (firstCategory) {
      dispatch(setActiveCategory(firstCategory));
      window.sessionStorage.setItem('menuTypeId', firstCategory.id);
      dispatch(pushMenuItemsByScreenId(firstCategory.id));
    }
    props.navigateTo('/orders');
    window.sessionStorage.removeItem('scrol');
  };


  const handleTitle = () => {
    const { tittle } = props.headerBar;
    let logo = '';
    switch (tittle) {
      case 'Logo':
        if (props?.popInData?.venue) {
          // logo = (props?.popInData?.venue?.desktopLogoImageUrl) || OneDineLogo;
        } else {
          logo = (props?.popInData?.store?.logoImageUrl);
        }
        return <img src={logo} alt="notFound" className={cn(window.innerWidth > 1023 ? `${styles.logoWidth}` : 'w-100', props?.popInData?.store?.logoImageUrl ? styles.logoSize : 'h-px-40')} role="presentation" onClick={() => onClickHandler()} />;
      case 'OneDineLogo':
        logo = (((props?.popInData?.store?.logoImageUrl))
        );
        return <img src={logo} alt="notFound" className={cn(!isMobile ? `${styles.logoWidth}` : 'w-100', props?.popInData?.store?.logoImageUrl ? styles.logoSize : 'h-px-40')} role="presentation" onClick={() => onClickHandler()} />;
      case 'StoreLogo':
        logo = (((props?.popInData?.store?.logoImageUrl))
        );
        return <img src={logo} alt="notFound" className={cn(!isMobile ? `${styles.logoWidth}` : 'w-100', props?.popInData?.store?.logoImageUrl ? styles.logoSize : 'h-px-40')} role="presentation" onClick={() => onClickHandler()} />;
      case 'BrandLogo':
        logo = (props?.themeProperties?.logoImageUrl);
        return <img src={logo} alt="notFound" className={cn(!isMobile ? `${styles.logoWidth}` : 'w-100', props?.themeProperties?.logoImageUrl ? cn(styles.logoSize, 'mw-100') : 'h-px-40')} role="presentation" onClick={() => onClickHandler()} />;
      default:
        return tittle;
    }
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const itemRefs = useRef([]);

  useEffect(() => {
    const id = props?.themeProperties?.languages?.findIndex(
      l => l.languageId === props.selectedLanguageId
    );
    if (id !== -1) {
      setActiveIndex(id);
      const el = itemRefs.current[id];
      if (el) el.focus();
    }

    const handleKeyDown = (event) => {
      if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return;

      event.preventDefault();

      setActiveIndex((prevIndex) => {
        const last = props.themeProperties.languages.length - 1;
        let nextIndex = prevIndex;

        if (event.key === 'ArrowUp') {
          nextIndex = prevIndex === 0 ? last : prevIndex - 1;
        } else {
          nextIndex = prevIndex === last ? 0 : prevIndex + 1;
        }

        const el = itemRefs.current[nextIndex];
        if (el) el.focus();
        return nextIndex;
      });
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [props.themeProperties?.languages, isLanguageModal]);

  const restrictProfileIcon = ['/wallet', '/orders-history', '/profile/basicInfo', '/profile/changePassword', '/account', '/wallet/address', '/wallet/loyalties', '/login', '/KDS'];
  const isProfileIcon = !restrictProfileIcon.includes(window.location.pathname) && !(window.location.pathname.includes('/receipt/display') || window.location.pathname === '/loyalty-offer-details') && !isMobile && userInfo.isUserLogin();

  const getPointerPosition = () => {
    let classname = '';
    if (isProfileIcon && !userWayAccountId) {
      classname = styles.pointerPosition1;
    } else if (!isProfileIcon && userWayAccountId) {
      classname = styles.pointerPosition2;
    } else if (!isProfileIcon && !userWayAccountId) {
      classname = styles.pointerPosition3;
    }
    return classname;
  };
  const handleRightIcon = () => {
    return (
      <>
        {window.location.pathname === '/orders'
      && (
      <div arial-label="order history" className={cn(styles.menu, 'd-flex align-items-center')} role="presentation" onClick={() => { props.sliderHandler(); window.sessionStorage.setItem('scrol', window.scrollY); }}>
        <button type="button" className={cn(styles.cartIcon, 'btn-outline-none border-0 bg-white p-0 d-flex justify-content-center align-items-center position-relative')} aria-label="account">
          <CartIcon activebackground="od-headerIcons-backgroundFill headerIcondefault" activeIcon="od-headerIcons-iconFill" />
          {props.getCartQuantity() > 0 && (
          <span className={cn('position-absolute fs-18 od-bg-stroke od-headerIcons-bubbleText od-headerIcons-bubbleFill', styles.quantity)}>{props.getCartQuantity()}</span>)}
        </button>
      </div>
      )}
        {renderLanguageHeader && (
        <div className={cn(props?.themeProperties?.languages?.length > 1 && `${styles.DesktoplanguageHeader} ml-3`)}>
          <div>
            {(props?.popInData?.theme?.languages?.length > 1 || props?.themeProperties?.languages?.length > 1) && (
            <button
              ref={iconRef}
              type="button"
              onClick={() => dispatch(showLanguageModal(!isLanguageModal))}
              style={{
                cursor: 'pointer',
              }}
              className="bg-transparent btn-outline-none border-0 bg-secondary-light p-0"
              aria-label="select language"
            >
              <LanguageIcon active="od-headerIcons-iconFill" />
              {/* <img src={languageData[props.selectedLanguageId]?.flag} alt="" className={styles.flagImages} /> */}
              {!isLanguageModal ? (
                <span className="position-fixed justify-content-center">
                  <LanguageArrow active="od-iconStyles-actionIcons defaultDisplayIconColor" />
                </span>
              ) : null}
            </button>
            )}
            {isLanguageModal && (

              <>
                <Portal>
                  <div className={cn(styles.languagebackdrop)} />
                </Portal>
                <div className={cn(styles.languagebackdrop)} />
                <div
                  ref={dropdownRef}
                  style={{
                    ...styless.popper,
                    zIndex: 10001,
                    background: '#fff',
                    padding: '10px',
                    borderRadius: '8px',
                    minWidth: '350px',
                    maxWidth: '500px',
                    paddingLeft: '16px',
                    paddingRight: '16px'
                  }}
                  {...attributes.popper}
                  className={cn(styles.deskToplanguagemodal, getPointerPosition(), (window.location.pathname === '/account' && styles.restrictprofile))}
                >
                  <div className="d-flex  align-items-center py-2 px-0">
                    <span className="fs-16 mx-auto fw-600">Select Languages</span>
                    <span
                      onClick={() => dispatch(showLanguageModal(false))}
                      role="presentation"
                    >
                      <CrossIcon active="od-iconStyles-actionIcons crossIconDefault" />
                    </span>
                  </div>

                  <div className={cn(styles.languagedivider, 'mb-2')} />
                  {props?.themeProperties?.languages.map((language, index) => (
                    <div
                      role="button"
                      tabIndex={index === activeIndex ? 0 : -1}
                      ref={(el) => {
                        itemRefs.current[index] = el;
                      }}
                      onKeyDown={(e) => { if (e.key === 'Spacebar' || e.key === 'Enter') { e.target.click(); } }}
                      key={language.languageId}
                      onClick={() => props.handleLanguageSelection(language.languageId)}
                      className={cn(
                        styles.deskToplanguageitem,
                        language.languageId === props.selectedLanguageId ? styles.selected : '', activeIndex >= 0 && index === activeIndex && styles.selected, 'col-12 px-2 d-flex justify-content-between align-items-center'

                      )}
                    >
                      {languageData[language.languageId] && (
                        <>
                          {/* <img className={styles.flagImages} src={languageData[language.languageId].flag} alt={`Flag for ${languageData[language.languageId].name}`} /> */}
                          <span className={cn(language.languageId === props.selectedLanguageId ? 'fs-16 fw-600' : styles.deskToplanguageText)}>{languageData[language.languageId].name}</span>
                        </>
                      )}
                      {language.languageId === props.selectedLanguageId && (
                        <span className="float-right pl-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M20.5 6.41L8.5 18.41L3 12.91L4.41 11.5L8.5 15.58L19.09 5L20.5 6.41Z" fill="#0142D3" />
                          </svg>
                        </span>
                      )}
                    </div>
                  ))}

                </div>
                {/* </div> */}
              </>

            )}
          </div>
        </div>
        )}
        {isProfileIcon
        && (
        <div className="d-flex justify-content-end ml-4">
          <button type="button" className={cn(!isMobile ? `${styles.size35}` : 'header-btn', 'btn-outline-none border-0 bg-secondary-light p-0 d-flex justify-content-center align-items-center')} aria-label="account" onClick={() => { props.navigateTo('/account'); dispatch(setCheckoutSlider(false)); document.body.classList.remove('panelOpen'); }} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === 'Spacebar') { e.target.click(); } }}>
            <ProfileIcon activeprofile=" od-headerIcons-iconFill" activebackground="headerIcondefault od-headerIcons-backgroundFill" />
          </button>
        </div>
        )
      }
        {userWayAccountId && <div className="ml-3"><AccessibilityIconButton popIn={props.popInData} /> </div>}
      </>
    );
  };

  const restrictODheader = window.location.pathname === '/account' || window.location.pathname === '/orders-history' || window.location.pathname === '/profile/basicInfo';
  const desktopBoxShadow = window.location.pathname === '/login' || window.location.pathname === '/account' || window.location.pathname === '/forgotpassword' || window.location.pathname === '/receipt/display';
  const closePages = ['/order-item/', '/orders-history', '/profile/basicInfo', '/tip', '/wallet', '/upsell', '/loyalty', '/profile/changePassword', '/account', '/scan-qr/1', '/payment-option', '/loyalty-offers', '/wallet/address', '/wallet/loyalties', '/login', '/gift-card', '/brandStoreDetails', '/coupon', '/KDS'];
  const rightIconType = closePages.includes(window.location.pathname) || window.location.pathname.includes('/order-item') || window.location.pathname.includes('/selected-cart') || window.location.pathname.includes('/lookup') ? 1 : 2;
  return (
    <div>
      <div className={cn('container', styles.desktopFooterContainer)}>
        <div className="row">
          <div className={cn('d-flex justify-content-around align-items-center w-100 p-0 m-0', styles.desktopFooterItems)}>
            <nav className={cn(!isMobile ? `${styles.top0}` : '', 'navbar position-fixed w-100   text-dark pb-0 p-0 od-header container-fluid desktopFixedPositionTemplate', `${styles.nav} ${restrictODheader && isMobile ? '' : 'od-header'}`, desktopBoxShadow && `${styles.loginHeaderBoxShadow}`)}>
              <div className={cn(!isMobile ? '' : 'mt-20', `${styles.padding18} od-bg-header flex-nowrap container-fluid`, props.isCheckoutSlider && styles.sliderHeader)}>
                <div className={cn(!isMobile ? '' : 'col-md-2')}>
                  {(props?.popInData?.store?.logoImageUrl && (

                    <span className={cn('fw-600 d-flex justify-content-start', props.headerBar.style, (handleTitle || '').length > 20 ? styles.headerTitle : 'fs-18')} role="presentation">
                      {handleTitle()}
                    </span>
                  )
                )}
                </div>

                { (window.location.pathname === '/orders') && (

                <div className={cn(props?.themeProperties?.languages?.length > 1 ? 'offset-md-6' : 'offset-md-7', 'px-0 col-md-2')}>
                  <div className="d-flex flex-row">
                    <label className="d-none" htmlFor="search">Search: </label>
                    <input type="text" value={props.searchString} className={cn(styles.searchBoxCalendar, styles.placeholderStyles, 'od-form-common-stroke-default od-form-common-BackgroundFill-default od-form-common-text-displayText')} placeholder={LABEL().ORS_SEARCH} onChange={e => props.onSearchChange(e.target.value)} aria-label="Search" aria-labelledby="search" title="search" />
                    {!props.searchString && <SearchIcon active={cn(styles.searchbar, 'od-form-common-icon-IconFill searchFormIconDefault')} />}
                    {props.searchString && (

                    <span role="presentation" className={cn(styles.searchCloseCalendar)} onClick={() => { props.onSearchChange(''); }} onKeyDown={(ev) => { if (ev.key === 'Escape') { props.onSearchChange(''); } }}>
                      <span className={cn(styles.divider)}>
                        <div
                          onKeyDown={e => e.stopPropagation()}
                          role="presentation"
                        >
                          <CrossIcon active="od-iconStyles-actionIcons crossIconDefault pl-2" />
                        </div>
                      </span>
                    </span>

                    )}
                  </div>

                </div>

                )}
                <>
                  {
                    !userInfo.isUserLogin() && window.location.pathname === '/dashboard' ? (
                      <>
                        {window.location.pathname === '/dashboard' && (
                        <div className="flex-row justify-content-end">
                          {/* {!isSensorCheckWithQRCode && ( */}

                          <div className={cn(styles.logoutLink)} onClick={() => props.onNavigate(`/login?backTo=${window.location.pathname}`)} role="presentation">
                            { !(window.location.pathname === '/login' || window.location.pathname === '/KDS' || window.location.pathname === '/forgotpassword') && (
                            <button type="button" aria-label="login" className={cn(`btn btnLightBlue od-btn-primary btn-outline-none ${isMobile ? `${styles.logoutBtn} fs-14 fw-600` : `${styles.logoutBtnDesktop} fs-16 fw-600`} ')`)}>
                              {LABEL().LOGIN}
                            </button>
                            )}
                          </div>

                        </div>
                        )}
                      </>
                    ) : (
                      <div className={cn('d-flex justify-content-between d-flex align-items-center')}>
                        {handleRightIcon(rightIconType)}
                      </div>
                    )}
                </>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DesktopMenu;
